import FooterToolbar from './footer-toolbar.vue';
export default FooterToolbar;


// WEBPACK FOOTER //
// ./src/components/footer-toolbar/index.js